export const authTestIDs = {
  login: {
    email: 'e2e_login-email',
    password: 'e2e_login-password',
    submit: 'e2e_login-submit',
  },
  signup: {
    email: 'e2e_signup-email',
    name: 'e2e_signup-name',
    password: 'e2e_signup-password',
    submit: 'e2e_signup-submit',
    code: {
      input: 'e2e_signup-code-input',
      submit: 'e2e_signup-code-submit',
    },
  },
  logout: {
    submit: 'e2e_logout-submit',
  },
  google: {
    submit: 'e2e_google-submit',
  },
};
